<template>
  <div id="app">
    <transition
      :name="isTransition ? '' : 'fade-transform'"
      mode="out-in"
    >
      <EmptyLayout />
    </transition>
    <page-loading :show-loading="showLoading" />
    <!-- 弹窗 -->
    <!-- 身份认证 -->
    <user-spend-valid-toast :visible="showUserSpendToast" @onClose="onCloseAutor" />
    <!-- 关注公众号 -->
    <AttentWechatToast v-if="showWechat" @onClose="onCloseWechatMask" />
    <!-- 未认证积分15日退回 -->
    <UserWorkAuthWarnModal :visible="showUserWorkAuthToast" @onCannel="onCannelWorkAuthToast" />
    <!-- 风控弹窗 -->
    <RiskControl :visible="isShowRisk" :risk-obj="riskObj" @onChange="onChangeRisk" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
const PageLoading = () => import('@/components/PageLoading')
const UserWorkAuthWarnModal = () => import('@/components/UserWorkAuthWarnModal')
const UserSpendValidToast = () => import('@/components/UserSpendValidToast')
const AttentWechatToast = () => import('@/components/AttentWechatToast')
const RiskControl = () => import('@/views/RiskControl/Index')
import { getToken } from '@/utils/storage'
import { env, isWxBrowser, isMiniprogram } from '@/utils/environment'
import { getCallBack, onGetAuthStatus } from '@/service/PayService'
import { removeOrderId, getOrderId, getLoadPageStatus, handleUserError } from '@/utils/util'
import { checkWechat } from '@/service/IndexService'
import EmptyLayout from '@/layout/EmptyLayout.vue'
import { checkDoctor } from '@/service/UserService'
import imManager from '@/utils/im-manager'

export default {
  name: 'App',
  components: {
    PageLoading,
    UserSpendValidToast,
    UserWorkAuthWarnModal,
    AttentWechatToast,
    RiskControl,
    EmptyLayout
  },
  data() {
    return {
      isOpen: false,
      showToast: false,
      showUserRealAuthToast: false,
      showUserWorkAuthToast: false,
      showWechat: false,
      hasLoad: false,
      req: {
        FeedList: [12],
        Index: [12],
        shopList: [10],
        mine: [8]
      },
      notifyShowMap: {},
      money: 0,
      funBeanActionRuleType: '',
      titleText: '',
      // 保存定时器ID，用于清理
      getUserSigTimer: null,
      imLoginTimer: null
    }
  },
  computed: {
    ...mapGetters(['showLoading', 'userType', 'imUserSig', 'imName', 'systemTimCode', 'TimSdkHasReady', 'showUserSpendToast', 'riskObj']),
    isShowRisk() {
      return this.riskObj.isShow
    },
    isTransition() {
      return ['/find',  '/index', '/shop/list', '/mine'].includes(this.$route.path)
    }
  },
  watch: {
    $route(to) {
      if (window.__wxjs_is_wkwebview) {
        if (!window.wxShareLink) {
          window.wxShareLink = window.location.href.split('#')[0]
        }
      }
      // 相关弹窗
      if (['Index', 'FeedList', 'shopList', 'mine'].includes(to.name) && this.userType === 'doctor' && !this.hasLoad) {
        this.hasLoad = true
        this.getUserNotify(this.req[to.name]).then(res => {
          this.hasLoad = false
          const showObj = res.data[0] || {}
          if (showObj.result) {
            // 每次进入程序，满足条件就弹
            if (!this.isOpen) {
              this.showWechat = this.isOpen = showObj.notifyType === 12
            }
            this.$store.commit('SET_USER_SPEND_VALID_STATUS', showObj.notifyType === 10)
            this.showUserWorkAuthToast = showObj.notifyType === 8
          }
        })
      }
      if (to.name === 'Index' || to.name === 'FeedList') {
        console.log('[$route watch] 路由变化:', to.path, 'to.name:', to.name, 'code:', to.query.code)
        this.onCheckAuthStatus(to.query.code)
      }
      if (['SystemMessage', 'Find', 'KnowledgeRoom', 'live', 'SpeakerConsole', 'WebinarDetail'].includes(to.name)) {
        this.imLogin()
      }
      // 获取平台劳务开启状态
      if (['PodcastInviteDetail', 'SpeakerGiftDetail', 'SpeakerInvite', 'SpeakerRmbAmount'].includes(to.name)) {
        this.getPlatformLaborServiceEnabled()
      }
    }
  },
  mounted() {
    // 线上环境，非微信环境，非预览页面，不允许访问（预览页面的this.$route.name为null）
    const isPublish = process.env.VUE_APP_BUILD_ENV === 'publish'
    if (!isWxBrowser() && isPublish && this.$route.name !== null && !this.isAllowedNonWechatPage(this.$route.name)) {
      this.$router.replace({ path: '/error' })
      return
    }

    // 初始化 IM 管理器
    imManager.init(this.$tim, this.$store)

    // 横屏监听
    this.listenWindow()
    this.$tim.on(window.TIM.EVENT.SDK_READY, this.onSdkReady)
    window.addEventListener('onorientationchange' in window ? 'orientationchange' : 'resize', this.listenWindow, false)
    this.onGetSpeakerHome()

    // 风控拦截
    this.checkRisk()
  },
  beforeDestroy() {
    // 移除横屏监听
    const eventType = 'onorientationchange' in window ? 'orientationchange' : 'resize'
    window.removeEventListener(eventType, this.listenWindow, false)

    // 移除IM事件监听
    if (this.$tim) {
      this.$tim.off(window.TIM.EVENT.SDK_READY, this.onSdkReady)
      if (this.onImReady) {
        this.$tim.off(window.TIM.EVENT.IM_READY, this.onImReady)
      }
    }

    // 清除定时器
    if (this.getUserSigTimer) {
      clearTimeout(this.getUserSigTimer)
      this.getUserSigTimer = null
    }
    if (this.imLoginTimer) {
      clearTimeout(this.imLoginTimer)
      this.imLoginTimer = null
    }
  },
  methods: {
    ...mapActions(['getImUserInfo', 'onSetPageOrientation', 'getSpeakerHome', 'getFunBeanList', 'getUserNotify', 'onAgreeNotify', 'setRiskObj', 'getPlatformLaborServiceEnabled', 'getFaceValidUrl']),
    async checkRisk() {
      try {
        const token = getToken()
        if (!token) return
        const userType = (token).split('_')[0]
        if (userType !== '1') return
        // 此处留坑，刷新的方式进入 app 是，都会去判断风控。
        if (!['/risk/result', '/user/support/center'].includes(window.location.pathname)) {
          await checkDoctor()
        }
      } catch (error) {
        handleUserError(error.code, this.$router)
      }
    },
    onChangeRisk(val) {
      this.setRiskObj({value: val, key: 'riskObj.isShow'})
    },
    listenWindow() {
      // 横屏判断
      if (window.orientation == 180 || window.orientation == 0) {
        // 竖屏状态
        this.onSetPageOrientation(false)
      }
      if (window.orientation == 90 || window.orientation == -90) {
        // 横屏状态
        this.onSetPageOrientation(true)
      }
    },
    imLogin() {
      if (!getToken() || this.TimSdkHasReady) return
      this.$nextTick(() => {
        if (this.imUserSig && this.imName) {
          this.$tim
            .login({
              userID: this.imName,
              userSig: this.imUserSig
            })
            .catch(rea => {
              if (rea.code === 70001 || rea.code === 6206 || rea.code === 20002) {
                this.imLoginTimer = setTimeout(() => {
                  this.getUserSig()
                }, 5000)
              }
              this.$msg(`im登陆异常：${rea.message}`)
            })
          return
        }
        this.getUserSig()
      })
    },
    getUserSig() {
      this.getImUserInfo().then(() => {
        this.$tim
          .login({
            userID: this.imName,
            userSig: this.imUserSig
          })
          .catch(rea => {
            if (rea.code === 70001 || rea.code === 6206 || rea.code === 20002) {
              this.getUserSigTimer = setTimeout(() => {
                this.getUserSig()
              }, 5000)
            }
            this.$msg(`im登陆异常：${rea.message}`)
          })
      })
    },
    onSdkReady() {
      this.$store.commit('TIM_SDK_READY')
    },
    onCheckWechat() {
      checkWechat().then(
        res => {
          isMiniprogram().then(result => {
            this.showWechat = !result && !res.data.subscribe
            if (!this.showWechat) {
              this.getFunBeanList().then(
                res => {
                  this.money = res.money
                  this.funBeanActionRuleType = res.funBeanActionRuleType
                  if (this.money && this.funBeanActionRuleType === 1 && res.isNotice === 1) {
                    this.showToast = true
                    this.titleText = '注册奖励'
                  } else if (this.money && this.funBeanActionRuleType === 2 && res.isNotice === 1) {
                    this.showToast = true
                    this.titleText = '每日登录奖励'
                  }
                }
              )
            }
          })
        },
        rea => {
          this.$msg(rea.message)
        }
      )
    },
    onCloseAutor() {
      this.$store.commit('SET_USER_SPEND_VALID_STATUS', false)
    },
    onCloseWechatMask() {
      this.showWechat = false
    },
    onCancel() {
      this.showToast = false
    },
    onCannelWorkAuthToast() {
      this.notifyShowMap = {}
      this.showUserWorkAuthToast = false
    },
    onGetSpeakerHome() {
      if (!getToken()) return
      this.$axios.get(this.$API.checkToken, { params: { token: getToken() } }).then(res => {
        if (res.data) {
          this.getSpeakerHome()
        }
      })
    },
    async onCheckAuthStatus(code) {
      // 调试日志：检查进入条件
      const token = getToken()
      const loadPageStatus = getLoadPageStatus()
      console.log('[onCheckAuthStatus] 进入检查')
      console.log('[onCheckAuthStatus] token:', !!token, 'loadPageStatus:', loadPageStatus)

      if (!token || loadPageStatus) {
        console.log('[onCheckAuthStatus] 提前返回：没有token或已加载过页面')
        return
      }

      // 调试日志
      console.log('[onCheckAuthStatus] code:', code)
      console.log('[onCheckAuthStatus] env:', env())

      const isYunZhiEntry = localStorage.getItem('entry_point') === 'yunzhi'
      if (isYunZhiEntry) {
        return
      }

      // 只处理普通入口的授权逻辑
      if (env() === 'pre' || env() === 'publish') {
        if (code) {
          try {
            const res = await getCallBack(code)
            // 普通入口的逻辑
            if (!res.data) {
              onGetAuthStatus()
            } else {
              const orderObj = getOrderId() || ''
              if (orderObj) {
                const obj = JSON.parse(orderObj)
                removeOrderId()
                const orderTradeFlowId = obj?.orderTradeFlowId || ''
                this.$router.push(`/pay/home?orderId=${obj.orderId}&orderTradeFlowId=${orderTradeFlowId}`)
                return
              }
            }
          } catch (error) {
            console.error('授权回调处理失败:', error)
          }
        } else {
          console.log('[onCheckAuthStatus] 没有 code 参数，调用 onGetAuthStatus')
          onGetAuthStatus()
        }
      } else {
        console.log('[onCheckAuthStatus] 非 pre/publish 环境，跳过授权处理')
      }
    },

    // 检查是否允许非微信浏览器访问的页面
    isAllowedNonWechatPage(routeName) {
      const allowedRoutes = [
        'QuestionnaireDetailPreview',
        'PreviewPureQuestionnaire',
        'RegisterDetailPreview'
      ]
      return allowedRoutes.includes(routeName)
    }
  }
}
</script>

<style lang="scss">
@import '@/styles/custom-vant-ui.scss';

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100%;
  height: 100%;
  padding-bottom: env(safe-area-inset-bottom);
}
input::-webkit-input-placeholder,
textarea::-webkit-input-placeholder {
  color: #c8c8c8;
}
input:-moz-placeholder,
textarea:-moz-placeholder {
  color: #c8c8c8;
}
input::-moz-placeholder,
textarea::-moz-placeholder {
  color: #c8c8c8;
}
input:-ms-input-placeholder,
textarea:-ms-input-placeholder {
  color: #c8c8c8;
}
.svg-icon {
  font-size: 5.6vw;
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}

// scss
.fade-transform-leave-active,
.fade-transform-enter-active {
  transition: all 0.2s;
}
.fade-transform-enter {
  opacity: 0;
  transform: translateX(0);
}
.fade-transform-leave-to {
  opacity: 0;
  transform: translateX(0);
}
</style>
